"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _cart = require("@bento-core/cart");
var _AddFiles = _interopRequireDefault(require("./AddFiles"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AddFilesRedux = function AddFilesRedux(props) {
  return /*#__PURE__*/_react.default.createElement(_AddFiles.default, props);
};

/**
* create query variable with actie filters
*/
var mapStateToProps = function mapStateToProps(state) {
  return {
    count: state.cartReducer && state.cartReducer.count
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addFiles: function addFiles(files) {
      dispatch((0, _cart.onAddCartFiles)(files));
    }
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddFilesRedux);
exports.default = _default;